import React, { useState } from 'react';
import axios from 'axios';
import { 
  FaFacebook, 
  FaTwitter, 
  FaLinkedin, 
  FaInstagram,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaArrowRight,
  FaExternalLinkAlt
} from 'react-icons/fa';
import './Footer.css';
import config from '../../config';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState({ type: '', message: '' });

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setNewsletterStatus({ type: '', message: '' });

    try {
      const response = await axios.post(`${config.apiUrl}/api/newsletter`, { email });
      
      if (response.data.success) {
        setNewsletterStatus({
          type: 'success',
          message: 'Successfully subscribed to our newsletter!'
        });
        setEmail('');
      }
    } catch (error) {
      setNewsletterStatus({
        type: 'error',
        message: error.response?.data?.message || 'Failed to subscribe. Please try again.'
      });
    }
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo-container">
              <img src="/logo.png" alt="Gebeta Tech" className="footer-logo-image" />
              <h3 className="footer-logo">Gebeta<span>Tech</span></h3>
            </div>
            <p>
              Leading technology solutions provider in Ethiopia. We transform 
              businesses through innovative web and mobile applications.
            </p>
            <div className="footer-social">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon"><FaFacebook /></a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon"><FaTwitter /></a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon"><FaLinkedin /></a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon"><FaInstagram /></a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><button type="button" onClick={() => scrollToSection('hero')}>Home</button></li>
              <li><button type="button" onClick={() => scrollToSection('services')}>Services</button></li>
              <li><button type="button" onClick={() => scrollToSection('about')}>About Us</button></li>
              <li><button type="button" onClick={() => scrollToSection('portfolio')}>Portfolio</button></li>
              <li><button type="button" onClick={() => scrollToSection('contact')}>Contact</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li><button type="button" onClick={() => scrollToSection('services')}>Website Development</button></li>
              <li><button type="button" onClick={() => scrollToSection('services')}>Mobile App Development</button></li>
              <li><button type="button" onClick={() => scrollToSection('services')}>App Integration</button></li>
              <li><button type="button" onClick={() => scrollToSection('services')}>E-Commerce Solutions</button></li>
              <li><button type="button" onClick={() => scrollToSection('services')}>Cloud Solutions</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Our Partners</h4>
            <div className="footer-partners">
              <a 
                href="https://www.mulewave.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="partner-card"
              >
                <img 
                  src="/partners/mulewave-logo.jpg" 
                  alt="MuleWave Logo" 
                  className="partner-logo" 
                />
                <div className="partner-info">
                  <span className="partner-name">MuleWave</span>
                  <span className="partner-domain">www.mulewave.com</span>
                </div>
                <FaExternalLinkAlt className="external-link-icon" />
              </a>

              <a 
                href="https://www.gedebtech.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="partner-card"
              >
                <img 
                  src="/partners/gedebtech-logo.jpg" 
                  alt="Gedeb Tech Logo" 
                  className="partner-logo" 
                />
                <div className="partner-info">
                  <span className="partner-name">Gedeb Tech</span>
                  <span className="partner-domain">www.gedebtech.com</span>
                </div>
                <FaExternalLinkAlt className="external-link-icon" />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <FaMapMarkerAlt />
                <span>Addis Ababa, Ethiopia<br />Kirkos Subcity</span>
              </div>
              <div className="footer-contact-item">
                <FaPhone />
                <span>+251 919 444 499</span>
              </div>
              <div className="footer-contact-item">
                <FaEnvelope />
                <span>info@gebetatech.com</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Newsletter</h4>
            <p>Subscribe to get the latest updates and offers.</p>
            <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit">
                <FaArrowRight />
              </button>
            </form>
            {newsletterStatus.message && (
              <div className={`newsletter-status ${newsletterStatus.type}`}>
                {newsletterStatus.message}
              </div>
            )}
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Gebeta Tech. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-of-service">Terms of Service</a>
            <a href="/cookie-policy">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

